import { render, staticRenderFns } from "./taskEdit.vue?vue&type=template&id=ef6f21fa&scoped=true&"
import script from "./taskEdit.vue?vue&type=script&lang=js&"
export * from "./taskEdit.vue?vue&type=script&lang=js&"
import style0 from "./taskEdit.vue?vue&type=style&index=0&id=ef6f21fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6f21fa",
  null
  
)

export default component.exports